import Icon from "components/Icon/Icon";
import { number, projectsLocalization, commonLocalization } from "localization";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import ScrollArea from "react-scrollbar";
import styled from "styled-components";

class LocalProjectTable extends Component {
  state = {
    sortState: {
      title: "",
      status: "",
    },
  };

  goToDetail = (projectId) => {
    this.props.history.push(`/local-projects/${projectId}`);
  };

  sortByType(type) {
    const { sortState } = this.state;
    const currentOrder = sortState[type];
    let newOrder;
    if (currentOrder === "" || currentOrder === "desc") {
      newOrder = "asc";
    } else {
      newOrder = "desc";
    }

    const newSortState = Object.keys(this.state.sortState).reduce(
      (acc, currKey) => {
        acc[currKey] = currKey === type ? newOrder : "";
        return acc;
      },
      {}
    );

    this.setState({ sortState: newSortState }, () =>
      this.props.sortByType(type, newOrder)
    );
  }

  render() {
    const { projects, selectedLanguage } = this.props;

    const {
      projectTable: {
        title: projectTableWideTitle,
        wards: wardsLabel,
        status: statusLabel,
        typeOfProject: typeOfProjectLabel,
      },
    } = projectsLocalization[selectedLanguage];

    const { title, status } = this.state.sortState;

    const sortedProjects = [...projects].sort((a, b) => {
      const { title, status } = this.state.sortState;

      if (title === "asc") {
        return selectedLanguage === "np"
          ? a.title_np.localeCompare(b.title_np)
          : a.title_en.localeCompare(b.title_en);
      } else if (title === "desc") {
        return selectedLanguage === "np"
          ? b.title_np.localeCompare(a.title_np)
          : b.title_en.localeCompare(a.title_en);
      }

      if (status === "asc") {
        return a.status.localeCompare(b.status);
      } else if (status === "desc") {
        return b.status.localeCompare(a.status);
      }

      return 0;
    });

    return (
      <TableWrapper
        className='table-wrap'
        lang={selectedLanguage}
        projectTableWideTitle={projectTableWideTitle}
        typeOfProjectLabel={typeOfProjectLabel}
        wardsLabel={wardsLabel}
        statusLabel={statusLabel}
      >
        <table>
          <thead>
            <tr>
              <th
                onClick={() => this.sortByType("title")}
                width='35%'
                className={title || ""}
              >
                <div className='flex items-center gap-1'>
                  <div className='sorting-icon'>
                    <Icon name={"arrow-up"} active={title === "asc"} />
                    <Icon name={"arrow-down"} active={title === "desc"} />
                  </div>
                  {projectTableWideTitle}
                </div>
              </th>
              <th width='30%'>{typeOfProjectLabel}</th>
              <th width='15%'>{wardsLabel}</th>
              <th
                onClick={() => this.sortByType("status")}
                width='20%'
                className={status || ""}
              >
                <div className='flex items-center gap-1'>
                  <div className='sorting-icon'>
                    <Icon name={"arrow-up"} active={status === "asc"} />
                    <Icon name={"arrow-down"} active={status === "desc"} />
                  </div>
                  {statusLabel}
                </div>
              </th>
            </tr>
          </thead>
        </table>
        <ScrollArea
          className='options'
          style={{ marginTop: 0 }}
          smoothScrolling={true}
          minScrollSize={30}
        >
          <table>
            <tbody>
              {sortedProjects.length > 0 &&
                sortedProjects.map((project) => (
                  <tr
                    key={project.id}
                    onClick={() => this.goToDetail(project.id)}
                  >
                    <td width='35%'>
                      <Link to={`/local-projects/${project.id}`}>
                        {selectedLanguage === "np"
                          ? project.title_np
                          : project.title_en}
                      </Link>
                    </td>
                    <td width='30%'>
                      {project.type_name
                        ? selectedLanguage === "np"
                          ? project.type_name.title_ne
                          : project.type_name.title_en
                        : ""}
                    </td>
                    <td width='15%'>{number(project.ward)}</td>
                    <td width='20%'>
                      <span className={`status status--${project.status}`}>
                        {project.status === "submitted"
                          ? commonLocalization[selectedLanguage].submitted
                          : commonLocalization[selectedLanguage].evaluated}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </ScrollArea>
      </TableWrapper>
    );
  }
}

const TableWrapper = styled.div`
  table tr th {
    font-size: ${(props) => (props.lang === "en" ? "12px" : "14px")};
    padding-bottom: 6px;
    cursor: pointer;

    &.asc,
    &.desc {
      background-position: ${(props) =>
        props.lang === "en" ? "-4px 15px" : "-4px 17px"};
    }
  }

  table tr td {
    font-size: ${(props) => (props.lang === "en" ? "14px" : "15px")};

    .status {
      font-size: ${(props) => (props.lang === "en" ? "12px" : "13px")};
      padding: ${(props) => (props.lang === "en" ? "4px 10px" : "2px 10px")};

      &:empty {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    td {
      min-height: 51px;

      &:before {
        font-size: ${(props) => (props.lang === "en" ? "12px" : "14px")};
      }
    }

    td:nth-of-type(1):before {
      content: ${(props) => "'" + props.projectTableWideTitle + "'"};
    }

    td:nth-of-type(2):before {
      content: ${(props) => "'" + props.typeOfProjectLabel + "'"};
    }

    td:nth-of-type(3):before {
      content: ${(props) => "'" + props.wardsLabel + "'"};
    }

    td:nth-of-type(4):before {
      content: ${(props) => "'" + props.statusLabel + "'"};
    }
  }
`;

const mapStateToProps = (state) => ({
  selectedLanguage: state.localizationReducers.selectedLanguage,
  fetching: state.infraMonitor.fetching,
});

export default withRouter(connect(mapStateToProps)(LocalProjectTable));



// WEBPACK FOOTER //
// ./src/pages/localProject/list/partials/project-table.js